<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
  <div class="row">
    <div class="col-12"></div>
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- ngx-datatable-filter -->
            <fieldset class="form-group">
              <div class="row align-items-end mt-0 pagination-body">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                  <div class="btn-group enrollment-list-btn-info" role="group">
                    <button class="btn enrollment-list-buttons cursor-pointer" type="button"
                      *ngFor="let status of statusList"
                      [ngClass]="{'btn-primary':activeTab ==status?.id,'btn-outline-primary':activeTab!=status?.id}"
                      (click)="activeCourseTab(status?.id,selected_category_tab)">{{status.name}}</button>
                    <div class="mx-2">
                      <ng-select [items]="category_list" bindLabel="displayname" bindValue="_id" placeholder="Select"
                        [(ngModel)]="selected_category_tab" [ngModelOptions]="{ standalone: true }"
                        (change)="getChangeCategory($event)">
                      </ng-select>
                    </div>
                    <div class="tags-box">
                      <ng-select [items]="tags_list" bindLabel="displayname" bindValue="_id" placeholder="Select"
                        [(ngModel)]="selected_tag_tab" [ngModelOptions]="{ standalone: true }"
                        (change)="getChangeTag($event)">
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                  <div class="row-flex">
                    <div class="col-flex-2 mb-1 position-relative">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search" #name [(ngModel)]="searchVal"
                        (keydown.enter)="getCourseFilter(searchVal)" />
                      <button class="btn search-btn glow position-absolute" (click)="getCourseFilter(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                        routerLink="/course/course-add-edit" placement="top" ngbTooltip="Add New">
                        +
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <button *ngIf="guideline_data" class="btn btn-outline-primary"
                    (click)="openDynamicModal(guideline_data)">Course Guideline</button>
                </div>
              </div>
              <div class="my-2">
                <span>Variation : <span>{{page.totalPages}}</span> &nbsp; <span>|</span> &nbsp; Total Courses :
                  <span>{{total_course_count}}</span> </span>
              </div>
            </fieldset>
            <div>
              <div *ngFor="let variant of rows; let i = index">
                <div class="main_heading cursor-pointer" (click)="collapse.toggle(i)"
                  [attr.aria-expanded]="courseTypeView[i]" aria-controls="collapseExample">
                  <h5 class="bg-light-info">
                    {{variant?.variations?.displayname ? variant?.variations?.displayname :'Others' }}
                    ({{variant.total}})</h5>
                </div>
                <ngx-datatable id="demo" #collapse="ngbCollapse" [ngbCollapse]="!courseTypeView[i]"
                  (ngbCollapseChange)="toggleCollapse(i)" class="bootstrap core-bootstrap"
                  [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                  [limit]="limitRef" [rows]="variant.course" [scrollbarH]="true" [columns]="columns"
                  [externalPaging]="true" [count]="variant.total" [offset]="page.offset"
                  (page)="pageChangeData($event)">
                  <ngx-datatable-column name="Course Name" prop="title">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      <div class="d-flex align-items-center">
                        <div *ngIf="row.image">
                          <img class="rounded-circle mr-1" [src]="imageUrl + row.image" height="32" width="32"
                            alt="datatable-avatar" />
                        </div>
                        <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                          <div class="avatar-content">
                            {{ row?.title | shortName }}
                          </div>
                        </div>
                        <div class="cell-line-height" (click)="viewCourse(row._id)">
                          <p class="font-medium-1 line-height-1 mb-0">
                            {{ row.title }}
                          </p>
                          <div class="d-flex flex-wrap type-box my-1">
                            <div class="my-1">
                              <span *ngFor="let mode of row?.course_mode"
                                class="badge bg-light-primary mx-1 my-1 cursor-pointer" placement="top"
                                ngbTooltip="Mode"
                                (click)="openMode(myModalMode,row?._id,row?.course_mode)">{{mode.displayname}}</span>
                            </div>
                            <div class="my-1" *ngFor="let duration of row?.duration">
                              <span class="badge bg-light-primary mx-1 cursor-pointer" placement="top"
                                ngbTooltip="Duration"
                                (click)="openDuration(myModalDuration,row?._id,duration)">{{duration.displayname}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Fees" prop="total_fees">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      {{ row.total_fees | currency: "INR" }}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Status" prop="course_status">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      <span mat-button [matMenuTriggerFor]="menuStatus">
                        <span *ngIf="row?.course_status ==='current'"
                          class="badge badge-pills bg-light-success cursor-pointer">{{ row?.course_status }}</span>
                        <span *ngIf="row?.course_status ==='archived'"
                          class="badge badge-pills bg-light-danger cursor-pointer">{{row?.course_status}}</span>
                      </span>
                      <mat-menu #menuStatus="matMenu" id="menuStatus">
                        <div *ngFor="let status of statusList">
                          <button mat-menu-item *ngIf="status?.id !== row?.course_status"
                            (click)="updateStatus(row?._id,status.id)">
                            <span *ngIf="status.id ==='current'"
                              class="badge badge-pills bg-light-success">{{status.name}}</span>
                            <span *ngIf="status.id ==='archived'"
                              class="badge badge-pills bg-light-danger">{{status.name}}</span>
                          </button>
                        </div>
                      </mat-menu>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Variation" prop="variations">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      <span class="cursor-pointer"
                        (click)="openModalForReferral(myModalVariations,row?.title,row?._id,variant?.variations?._id)">
                        {{ variant?.variations?.displayname }}
                      </span>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Web" prop="published_web" [width]="10">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      <div>
                        <mat-slide-toggle color="primary" [checked]="row?.published_web"
                          (change)="publishUnpublishWeb(row)"></mat-slide-toggle>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="App" prop="published_app" [width]="10">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                      <div>
                        <mat-slide-toggle color="primary" [checked]="row?.published_app"
                          (change)="publishUnpublishApp(row)"></mat-slide-toggle>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Actions"
                    *ngIf="user_role.roles ==='admin' || empType.includes('Managment') || empType.includes('Training Moderator') || empType.includes('Teacher')">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <i *ngIf="user_role.roles ==='admin' || empType.includes('Managment') || empType.includes('Training Moderator') || empType.includes('Teacher')"
                        class="ft-more-vertical text-primary cursor-pointer mx-1" mat-button
                        [matMenuTriggerFor]="menu"></i>
                      <mat-menu #menu="matMenu" id="menu">
                        <button mat-menu-item
                          *ngIf="user_role.roles ==='admin' || empType.includes('Managment') || empType.includes('Training Moderator') || empType.includes('Teacher')"
                          (click)="confirmUpdate(row._id,'edit course','')">
                          Edit
                        </button>
                        <button mat-menu-item *ngIf="user_role.roles ==='admin'"
                          [routerLink]="['/course/course-manage', row._id]">
                          Reports
                        </button>
                        <button mat-menu-item (click)="confirmUpdate(row._id,'edit lms',row?.password)">
                          Edit Lms
                        </button>
                        <button mat-menu-item (click)="confirmUpdate(row._id,'student lms',row?.password)">
                          View Student Lms
                        </button>
                        <button mat-menu-item
                          *ngIf="empType.includes('Managment') || empType.includes('Training Moderator') || user_role.roles =='admin'"
                          [routerLink]="['/course/course-manage', row._id]">
                          Course Manage
                        </button>
                      </mat-menu>


                      <i class="ft-settings text-primary cursor-pointer mx-1" mat-button [matMenuTriggerFor]="menu2"
                        *ngIf="user_role.roles ==='admin' || empType.includes('Managment') || empType.includes('Training Moderator')"></i>
                      <mat-menu #menu2="matMenu" id="menu2">
                        <button mat-menu-item (click)="copyCourseLinkMeanderTraining(row)">
                          Meander Training URL
                        </button>
                        <button mat-menu-item (click)="copyCourseLinkMeanderSoftware(row)">
                          Meander Software Url
                        </button>
                      </mat-menu>

                    </ng-template>
                  </ngx-datatable-column>
                </ngx-datatable>
              </div>
            </div>

            <!-- ngx-datatable-filter -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>

<!------------- Variations Popup --------------------------------------->
<div>
  <ng-template #myModalVariations>
    <div class="modal-header">
      <h4 class="modal-title">{{row_name}}'s Variations</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <fieldset class="form-group">
        <label>Variations</label>
        <ng-select [items]="variationList" bindLabel="displayname" bindValue="_id" placeholder="Select Variation"
          [(ngModel)]="selectedVariation" [ngModelOptions]="{ standalone: true }" (change)="getVariationId($event)">
        </ng-select>
      </fieldset>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Close</button>
      <button type="button" class="btn btn-primary" (click)="updateVariation()">Submit</button>
    </div>
  </ng-template>
</div>
<!------------- Mode Update ------- ------------->
<div>
  <ng-template #myModalMode let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Mode Update</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-select [items]="mode_List" bindLabel="displayname" bindValue="_id" placeholder="Select Mode"
        [(ngModel)]="selected_mode" [multiple]="true" [ngModelOptions]="{ standalone: true }"
        (change)="getModeId($event)" [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
      </ng-select>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="updateMode()">Submit</button>
    </div>
  </ng-template>
</div>

<!------------- Duration Update ------- ------------->
<div>
  <ng-template #myModalDuration let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Duration Update</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-select [items]="duration_List" bindLabel="displayname" bindValue="_id" placeholder="Select Duration"
        [(ngModel)]="selected_duration" [ngModelOptions]="{ standalone: true }" (change)="getDurationId($event)"
        [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
      </ng-select>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="updateDuration()">Submit</button>
    </div>
  </ng-template>
</div>